import { render, staticRenderFns } from "./BadgeAttachement.vue?vue&type=template&id=8ea448bc&scoped=true&"
var script = {}
import style0 from "./BadgeAttachement.vue?vue&type=style&index=0&id=8ea448bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea448bc",
  null
  
)

export default component.exports